import React from 'react';
import { InputContainer } from '../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';

export const OrderPolicyBasicInfoComponent = ({entityTypes, onInnerBasicFormChange, selectedOrderPolicys,  }: any) => (

  <><AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
           <InputContainer

label="Active"
name="IsActive"
onValueChange={(event: any) => {
  onInnerBasicFormChange(
    event,
    'IsActive'
  )
}}
type="checkbox"
value={selectedOrderPolicys?.IsActive}
/>

<InputContainer
label="Name"
name="Name"
onValueChange={(event: any) => {
  onInnerBasicFormChange(
    event.target.value,
    'Name'

  )
}}
type="text"
value={selectedOrderPolicys?.Name}
/>


<InputContainer

label="Order Type"
labelField="Text"
list={entityTypes}
onValueChange={(event: any) => {
 onInnerBasicFormChange(
   event.target.value,
   'OrderTypeId'

 );
}}
optionName='Choose Order Type'
type="select"
value={selectedOrderPolicys?.OrderTypeId}
valueField="Value"
/>


<InputContainer
  label="Start Date"
  name="StartDateUtc"
  onValueChange={(event: any) => {
    onInnerBasicFormChange(
      event.target.value,
      'StartDateUtc'
    )
  }}
  type="date"
  value={selectedOrderPolicys?.StartDateUtc}
/>

<InputContainer
  label="End Date"
  name="EndDateUtc"
  onValueChange={(event: any) => {
    onInnerBasicFormChange(
      event.target.value,
      'EndDateUtc'
    )
  }}
  type="date"
  value={selectedOrderPolicys?.EndDateUtc}
/>

<InputContainer

label="Display Order"
name="DisplayOrder"
onValueChange={(event: any) => {
  onInnerBasicFormChange(
    event.target.value,
    'DisplayOrder'
  )
}}
type="number"
value={selectedOrderPolicys?.DisplayOrder}
/>

<InputContainer
label="Remarks"
name="Remarks"
onValueChange={(event: any) => {
  onInnerBasicFormChange(
    event.target.value,
    'Remarks'

  )
}}
type="text"
value={selectedOrderPolicys?.Remarks}
/>
<div className='col-span-full'>
<InputContainer
label="Description"
name="Description"
onValueChange={(event: any) => {
  onInnerBasicFormChange(
    event.target.value,
    'Description'

  )
}}
type="text"
value={selectedOrderPolicys?.Description}
/>
   </div>
   </div>
   }
   expandedPanel="Basic Info"
   headerTitle="Basic Info"
 />
        </>

)
export default OrderPolicyBasicInfoComponent;
